import Loader from '../../../../ui/loader/Loader';
import ChatContext from '../../contexts/ChatContext';
import { FC, Suspense } from 'react';
import { ContextProviderProps } from '../../types/chat.types';

const ContextProvider: FC<ContextProviderProps> = ({ children, value, config, onReloadChats }) => {
    return (
        <ChatContext.Provider value={{ value, config, onReloadChats }}>
            <Suspense fallback={<Loader />}>
                {children}
            </Suspense>
        </ChatContext.Provider>
    );
};

export default ContextProvider;
